/**
 * Lightweight replacement for lodash.debounce
 * Delays function execution until after `wait` milliseconds have elapsed since last call
 * 
 * @param func - Function to debounce
 * @param wait - Delay in milliseconds  
 * @param immediate - Execute on leading edge (default: false)
 * @returns Debounced function
 * 
 * @example
 * ```typescript
 * const debouncedSearch = debounce(searchAPI, 300);
 * input.addEventListener('input', debouncedSearch);
 * ```
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function debounce(func: Function, wait: number, immediate: boolean = false) {
  let timeout: any;
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function(this: any, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    clearTimeout(timeout);
    if (immediate && !timeout) func.apply(context, args);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
  };
}
